import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Confirmation } from '../model/confirmation';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {

  public confirmationMessage$: BehaviorSubject<Confirmation> = new BehaviorSubject(null);
  public confirmationCheckboxChecked$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public confirmationModule$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public textareaValue$: BehaviorSubject<string> = new BehaviorSubject('');
  private saveDataResolve: (value?: boolean | PromiseLike<boolean>, checkboxOptionChecked?: boolean | PromiseLike<boolean>) => void;

  constructor() { }

  //we need to add after closed to confirmation dialog
  public confirm(confirmation: Confirmation) {
    return new Promise<boolean>((resolve) => {
      this.saveDataResolve = resolve;
      this.confirmationMessage$.next(confirmation);
    });
  }

  public confirmModule() {
    return new Promise<boolean>((resolve) => {
      this.saveDataResolve = resolve;
      this.confirmationModule$.next(true);
    });
  }

  public onConfirmMessageAction(value: boolean, checkboxOptionChecked: boolean) {
    this.confirmationCheckboxChecked$.next(checkboxOptionChecked);
    this.saveDataResolve(value);
  }

  public setTextareaValue(value: string) {
    this.textareaValue$.next(value);
  }

  public getTextareaValue(): string {
    return this.textareaValue$.value;
  }
}
